import React from "react";

const DivisionTable = ({ divisions, phaseTabs, activeTab, setActiveTab, setSelectedPlayer }) => {
  return (
    <div className="space-y-8">
      <div className="rounded-lg bg-gray-800 p-6 shadow-lg">
        <h2 className="mb-4 text-2xl font-semibold text-center">Groups</h2>

        {/* TABS */}
        <div className="flex space-x-2 justify-center mb-4">
          {phaseTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2 rounded ${
                activeTab === tab.id ? "bg-blue-600" : "bg-gray-700"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* CONTENIDO DE PHASE I */}
        {activeTab === "phase1" ? (
          <div className="space-y-6">
            <h3 className="mb-2 text-xl font-semibold text-center text-blue-400">
              La Conquista de los Sistemas Fracturados
            </h3>

            {divisions.map((division, index) => (
              <div key={index} className="rounded-lg bg-gray-700 p-4">
                <h3 className="mb-2 text-xl font-semibold text-center text-blue-400">
                  {division.division}
                </h3>

                <table className="w-full table-auto">
                  <thead>
                    <tr className="bg-gray-600">
                      <th className="px-2 py-1 text-left">Pos.</th>
                      <th className="px-2 py-1 text-left">Player</th>
                      <th className="px-2 py-1 text-center">GP</th>
                      <th className="px-2 py-1 text-center">TP</th>
                    </tr>
                  </thead>

                  <tbody>
                    {division.players.map((player, i) => (
                      <tr key={i} className="hover:bg-gray-600">
                        <td className="px-2 py-1">{i + 1}</td>

                        <td className="px-2 py-1">
                          <button
                            className="text-blue-400 hover:underline"
                            onClick={() => setSelectedPlayer(player)}
                          >
                            {player.nick}
                          </button>
                        </td>

                        <td className="px-2 py-1 text-center">{player.played}</td>
                        <td className="px-2 py-1 text-center">{player.points}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-gray-400">
            No data available for this phase.
          </p>
        )}
      </div>
    </div>
  );
};

export default DivisionTable;
